<template>
    <div class="login">
        <div class="wrap" id="wrap">
            <div class="logGet">
                <!-- 头部提示信息 -->
                <div class="logD logDtip">
                    <p class="p1">登录</p>
                </div>
                <!-- 输入框 -->
                <div class="lgD">
                    <img src="../assets/login_user_icon.png" width="20" height="20" alt=""/>
                    <input v-model="userName" type="text" placeholder="输入用户名"/>
                </div>
                <div class="lgD">
                    <img src="../assets/login_pwd_icon.png" width="20" height="20" alt=""/>
                    <input  v-model="password" type="password" placeholder="输入用户密码"/>
                </div>
                <div class="logC">
                    <a>
                        <button @click="login">登 录</button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import common from '../utils/utils'
    import commonApi from '../utils/commonapi'
    import apis from "../http/api";
    export default {
        name: "login",
        data(){
          return {
              userName:"",
              password:""
          }
        },
        methods: {
            login() {
                let post_data = {
                    'user_name': this.userName,
                    'password': common.toMd5(this.password)
                };
                apis.user_login(post_data).then(res=>{
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        // console.log(data.access_token)
                        common.setToken(data.access_token)
                        // 记录-登录
                        commonApi.recordCreate(commonApi.TypeLogin,null)
                        this.$router.replace('/pages');
                    }else {
                        alert(msg)
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .login {
        width: 100%;
        height: 100vh;
        background-image: url(../assets/login3.jpg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center center;
    }

    * {
        margin: 0;
        padding: 0;
    }

    #wrap {
        height: 600px;
        width: 100%;
        background-position: center center;
        position: relative;

    }

    #head {
        height: 120px;
        width: 100px;
        background-color: #66CCCC;
        text-align: center;
        position: relative;
    }

    #wrap .logGet {
        height: 408px;
        width: 368px;
        position: absolute;
        background-color: #FFFFFF;
        top: 100px;
        right: 15%;
    }

    .logC a button {
        width: 100%;
        height: 45px;
        background-color: #ee7700;
        border: none;
        color: white;
        font-size: 18px;
    }

    .logGet .logD.logDtip .p1 {
        display: inline-block;
        font-size: 28px;
        margin-top: 30px;
        width: 86%;
    }

    #wrap .logGet .logD.logDtip {
        width: 86%;
        border-bottom: 1px solid #ee7700;
        margin-bottom: 60px;
        margin-top: 0px;
        margin-right: auto;
        margin-left: auto;
    }

    .logGet .lgD img {
        position: absolute;
        top: 12px;
        left: 8px;
    }

    .logGet .lgD input {
        width: 100%;
        height: 42px;
        text-indent: 2.5rem;
    }

    #wrap .logGet .lgD {
        width: 86%;
        position: relative;
        margin-bottom: 30px;
        margin-top: 30px;
        margin-right: auto;
        margin-left: auto;
    }

    #wrap .logGet .logC {
        width: 86%;
        margin-top: 0px;
        margin-right: auto;
        margin-bottom: 0px;
        margin-left: auto;
    }


    .title {
        font-family: "宋体";
        color: #FFFFFF;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /* 使用css3的transform来实现 */
        font-size: 36px;
        height: 40px;
        width: 30%;
    }

    .copyright {
        font-family: "宋体";
        color: #FFFFFF;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /* 使用css3的transform来实现 */
        height: 60px;
        width: 40%;
        text-align: center;
    }
</style>